import { RootState } from '../store';
import { getWorkspaceName } from '../workspaces/selectors';

export const getTableApplications = (state: RootState) => state.applications.table;
export const getAllApplications = (state: RootState) => state.applications.all;

export const getApplicationName = (state: RootState) => {
    return (id: string) => {
        const app = state.applications.all.find((e) => e.id === id);
        if (app) {
            return app.title || app.id;
        } else {
            return '...'; // id;
        }
    };
};

export const applicationOptions = (state: RootState) => {
    return state.applications.all.map((application) => {
        return {
            label: application.server.hostname + ' | ' + application.title,
            value: application.id,
        };
    });
};

export const getSingleApplication = (state: RootState) => state.applications.singleApplication;